function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Raptivity-2_1"
}, React.createElement("rect", {
  width: 100,
  height: 37
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Raptivity-2_1",
  "data-name": "Raptivity-2 \\u2013 1",
  clipPath: "url(#clip-Raptivity-2_1)"
}, React.createElement("g", {
  id: "Group_19",
  "data-name": "Group 19",
  transform: "translate(-37.762 -7.813)"
}, React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12",
  transform: "translate(37.762 15.813)"
}, React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M38.986,21.832s-8.305,1.5-8.218,5.3c0,0-1.06,5.037,25.006,7.334,0,0,25.888,2.177,46.39-.8a57.864,57.864,0,0,0,14.049-3.27s-18.556,3.623-51.249,2.033c0,0-35.257-1.944-30.131-8.218C34.834,24.218,35.187,23.334,38.986,21.832Z",
  transform: "translate(-30.762 -13.321)",
  fill: "#02df82"
}), React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3",
  transform: "translate(11.095 0)"
}, React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M61.864,20.431c.265.325.122.631-.305.631H58.953a.71.71,0,0,1-.631-.305L54.855,16.38H53.6v4.173a.461.461,0,0,1-.509.509H50.852a.461.461,0,0,1-.509-.509V7.322a.461.461,0,0,1,.509-.509h4.987A4.873,4.873,0,0,1,60.724,11.7,4.712,4.712,0,0,1,58.2,15.78l3.659,4.65ZM53.6,13.53h2.239A1.725,1.725,0,0,0,57.468,11.7a1.725,1.725,0,0,0-1.629-1.832H53.6Z",
  transform: "translate(-50.343 -6.813)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M82.289,17.545v5.9a.461.461,0,0,1-.509.509H79.825a.461.461,0,0,1-.509-.509v-.291a3.219,3.219,0,0,1-2.626,1.085,3.181,3.181,0,1,1,0-6.351,4.136,4.136,0,0,1,2.626.776v-.919c0-1-.407-1.446-1.262-1.446a1.2,1.2,0,0,0-1.181.59c-.122.285-.224.448-.529.448H74.35a.459.459,0,0,1-.509-.53c.265-2.2,2.137-3.318,4.214-3.318C80.293,13.494,82.289,14.8,82.289,17.545Zm-2.972,3.521c0-.631-.55-1.018-1.547-1.018-.936,0-1.384.427-1.384,1.018s.448,1.018,1.384,1.018C78.767,22.084,79.316,21.657,79.316,21.066Z",
  transform: "translate(-60.305 -9.708)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M105.728,18.868a5.11,5.11,0,0,1-4.865,5.374,3.825,3.825,0,0,1-3.033-1.236v4.513a.461.461,0,0,1-.509.509H95.286a.461.461,0,0,1-.509-.509V14.288a.461.461,0,0,1,.509-.509h2.035a.461.461,0,0,1,.509.509v.442a3.825,3.825,0,0,1,3.033-1.236A5.111,5.111,0,0,1,105.728,18.868Zm-3.053,0a2.423,2.423,0,1,0-4.844,0,2.423,2.423,0,1,0,4.844,0Z",
  transform: "translate(-69.598 -9.708)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M123.824,12.015v1.914a.461.461,0,0,1-.509.509H122.2v6.738a.461.461,0,0,1-.508.509h-2.036a.461.461,0,0,1-.509-.509V14.438h-1.119a.461.461,0,0,1-.509-.509V12.015a.461.461,0,0,1,.509-.509h1.119V8.759a.461.461,0,0,1,.509-.509h2.036a.461.461,0,0,1,.508.509v2.748h1.12A.461.461,0,0,1,123.824,12.015Z",
  transform: "translate(-79.451 -7.436)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M133.318,23.666v-9.16a.461.461,0,0,1,.509-.509h2.035a.461.461,0,0,1,.509.509v9.16a.461.461,0,0,1-.509.509h-2.035A.461.461,0,0,1,133.318,23.666Z",
  transform: "translate(-86.3 -9.926)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M153.142,14.587l-3.318,9.18a.568.568,0,0,1-.57.407h-2.2a.568.568,0,0,1-.57-.407l-3.318-9.18c-.122-.367.061-.59.428-.59h2.178a.549.549,0,0,1,.57.427l1.812,5.837,1.812-5.837a.549.549,0,0,1,.57-.427h2.2C153.1,14,153.264,14.221,153.142,14.587Z",
  transform: "translate(-90.552 -9.926)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M165.287,23.666v-9.16A.461.461,0,0,1,165.8,14h2.035a.461.461,0,0,1,.509.509v9.16a.461.461,0,0,1-.509.509H165.8A.461.461,0,0,1,165.287,23.666Z",
  transform: "translate(-100.154 -9.926)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M181.655,12.015v1.914a.461.461,0,0,1-.509.509h-1.119v6.738a.461.461,0,0,1-.509.509h-2.036a.461.461,0,0,1-.509-.509V14.438h-1.119a.461.461,0,0,1-.509-.509V12.015a.461.461,0,0,1,.509-.509h1.119V8.759a.461.461,0,0,1,.509-.509h2.036a.461.461,0,0,1,.509.509v2.748h1.119A.461.461,0,0,1,181.655,12.015Z",
  transform: "translate(-104.512 -7.436)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M196.887,14h2.2c.367,0,.55.2.428.57l-4.4,13.272a.554.554,0,0,1-.59.407h-2.2c-.366,0-.55-.2-.427-.569l1.221-3.664-3.582-9.425c-.122-.346.041-.59.407-.59h2.2a.569.569,0,0,1,.57.407l1.933,5.395,1.669-5.374A.548.548,0,0,1,196.887,14Z",
  transform: "translate(-110.645 -9.926)",
  fill: "#fff"
})), React.createElement("rect", {
  id: "Rectangle_5",
  "data-name": "Rectangle 5",
  width: 3.053,
  height: 2.85,
  rx: 0.898,
  transform: "translate(58.114)",
  fill: "#02df82"
}), React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  width: 3.053,
  height: 2.85,
  rx: 0.898,
  transform: "translate(76.229)",
  fill: "#02df82"
}))));
var SvgRaptivity = function SvgRaptivity(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 100,
    height: 37,
    viewBox: "0 0 100 37",
    ref: svgRef
  }, props), _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRaptivity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Raptivity.d2585b8d.svg";
export { ForwardRef as ReactComponent };